import { getCurrentInstance, computed, reactive } from 'vue';
import { ModuleContract } from '@/stores/moduleConst';
import { useStore } from 'vuex';

// Combo grid Tài khoản nợ, có
export const useCacheContractComboConfig = () => {
  const { proxy } = getCurrentInstance();

  const store = useStore();

  const contractCombo = computed(() => {
    const contracts = store.getters[`${ModuleContract}/items`];
    return contracts.filter(x => !x.inactive);
  });

  // config columns combo
  const cacheContractComboConfig = reactive({
    data: contractCombo,
    columns: [
      {
        title: 'Mã hợp đồng',
        dataField: 'contract_no',
        width: 110,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên hợp đồng',
        dataField: 'description',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 490,
      },
    ],
    displayField: 'contract_no',
    valueField: 'contract_id',
    queryMode: 'local',
    dropdownWidth: 600,
    quickSearch: 'LocalQuickSearchPopup',
    quickSearchParam: {
      idField: 'contract_id',
      titleSearch: 'Tìm nhanh hợp đồng',
    },
  });

  return { cacheContractComboConfig };
};
